import { render, staticRenderFns } from "./upload_file.vue?vue&type=template&id=032dbf96&scoped=true&"
import script from "./upload_file.vue?vue&type=script&lang=js&"
export * from "./upload_file.vue?vue&type=script&lang=js&"
import style0 from "./upload_file.vue?vue&type=style&index=0&id=032dbf96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vbimex/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032dbf96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../vbimex/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VSpacer})
